<template>
  <div class="return-register">
    <div class="register-container">
      <p class="register-title">运单登记</p>
      <el-form ref="form" :model="register" label-width="80px">
        <el-form-item label="承运商：" prop="expressType">
          <el-select
            v-model="register.expressType"
            filterable
            clearable
            class="gray"
            placeholder="请选择承运商"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号：" prop="expressCode">
          <el-input class="white" v-model="register.expressCode" placeholder="请输入运单号" />
        </el-form-item>
        <el-button :disabled="register.isAutoSubmit" :class="!register.isAutoSubmit?'btn-blue':'btn-gray'" @click="registerFnc">登记</el-button>
        <el-switch
          class="auto-submit"
          v-model="register.isAutoSubmit"
          active-color="#2E68EA"
          active-text="自动提交"
          inactive-color="#CCCCCC">
        </el-switch>
      </el-form>
    </div>
    <div class="return-content">
      <el-form ref="searchForm" class="search-form" :model="searchForm" label-width="80px">
        <div class="search-row">
          <el-form-item label="承运商：" prop="expressType">
            <el-select
              v-model="searchForm.expressType"
              filterable
              clearable
              class="gray"
              placeholder="请选择承运商"
            >
              <el-option
                v-for="item in logisticsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="运单号：" prop="expressCode">
            <el-input class="white" v-model="searchForm.expressCode" placeholder="请输入运单号" />
          </el-form-item>
        </div>
        <div class="search-row">
          <el-form-item label="状态：" prop="status">
            <el-select
              v-model="searchForm.status"
              filterable
              clearable
              class="gray"
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-blue" @click="searchData">搜索</el-button>
            <el-button class="btn-white" @click="reset('searchForm')">清空</el-button>
            <el-button class="btn-blue" @click="downExcel">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item,index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="scope.row.status?'processed':'not-processed'">
                <i :class="scope.row.status?'el-icon-success':'el-icon-warning'"></i>
                {{scope.row[item.prop]}}
              </div>
              <p v-else>{{scope.row[item.prop]}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button 
                :disabled="scope.row.status == 1"
                type="text" 
                :class="!scope.row.status?'btn-text':'btn-text-gray'" 
                @click="del(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import ReturnRegister from "models/return-register";
import Logistics from "models/logistics";
const logistics = new Logistics();
import { formatTimeToDate } from "common/js/util";
export default {
  data() {
    return {
      register: {
        expressType: null,
        expressCode: '',
        isAutoSubmit: true
      },
      searchForm: {
        expressType: null,
        expressCode: '',
        date: '',
        status: '',
      },
      statusList: [
        {id:0, name: '未处理'},
        {id:1, name: '已处理'}
      ],
      logisticsList: [],
      tableData: [],
      tableTitle: [
        {label: '日期', prop: 'date'},
        {label: '承运商', prop: 'expressName'},
        {label: '单号', prop: 'expressCode'},
        {label: '状态', prop: 'statusVal'},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      statusObj: {
        0: '未处理',
        1: '已处理'
      }
    };
  },
  components: {
    PaginationTpl
  },
  watch: {
    'register.isAutoSubmit': {
      handler(newVal) {
        if (!newVal) {
          console.log('取消监听');
          window.document.onkeypress = null
        } else {
          console.log('开启监听');
          this.watchBarCodeScanningGun()
        }
      }
    }
  },
  created() {
    this.getLogisticsList()
    this.initList()
    this.watchBarCodeScanningGun()
  },
  destroyed() {
    window.document.onkeypress = null
  },
  methods: {
    /* 获取快递类型 */
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
        }
      });
    },
    //获取列表
    initList() {
      let pageNo = this.currentPage;
      let carrierId = this.searchForm.expressType;
      let expressCode = this.searchForm.expressCode;
      let date = this.searchForm.date;
      let hasDeal = this.searchForm.status;
      let data = {
        pageNo,
        carrierId,
        expressCode,
        date,
        hasDeal
      }
      ReturnRegister.getList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.date = value.createTime != 0? formatTimeToDate(value.createTime) :'';
            obj.expressName = value.carrier;
            obj.expressCode = value.expressCode;
            obj.status = value.hasDeal;
            obj.statusVal = this.statusObj[value.hasDeal];
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message)
        }
      });
    },
    searchData() {
      this.currentPage = 1
      this.initList();
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    downExcel() {
      let carrierId = this.searchForm.expressType;
      let expressCode = this.searchForm.expressCode;
      let date = this.searchForm.date;
      let hasDeal = this.searchForm.status;
      let data = {
        carrierId,
        expressCode,
        date,
        hasDeal
      }
      ReturnRegister.getExportExcel(data).then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },
    registerFnc() {
      let carrierId = this.register.expressType
      let expressCode = this.register.expressCode
      let data = {
        carrierId,
        expressCode
      };
      ReturnRegister.postRegister(data).then(res => {
        if (res.success) {
          this.initList();
          this.register.expressCode = ''
          this.$message.success("登记成功");
        } else {
          this.register.expressCode = ''
          this.$message.error(res.message);
        }
      });
    },
    del(id) {
      this.$confirm("删除后不可恢复，是否继续？?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ReturnRegister.postDelList(id).then(res => {
            if (res.success) {
              this.initList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    // 监听扫码枪
    watchBarCodeScanningGun() {
      let code = ''
      let lastTime, nextTime // 上次时间，最新时间
      let lastCode, nextCode // 上次按键，最新按键
      window.document.onkeypress = (e) => {
        // 获取按键
        if (window.event) { // IE
          nextCode = e.keyCode
        } else if (e.which) {
          nextCode = e.which
        }

        // 如果触发了回车事件（扫码结束时间）
        if (e.which === 13) {
          // 扫码枪的速度很快，手动输入的时间不回让code的长度大于2，所以这里只对邵美琪有效
          if (code.length < 3) return
          // 获取到扫码枪输入的内容，做别的操作
          this.parseQRCode(code)
          lastCode = ''
          lastTime = ''
          return
        }

        // 记录最新时间
        nextTime = new Date().getTime()
        // 如果上次时间和上次按键为空
        if (!lastTime && !lastCode) {
          // 清空上次的条形码
          code = ''
          code += e.key
          console.log('扫码开始', code);
        }
        // 如果有上次时间和上次按键
        if (lastTime && lastTime && nextTime - lastTime > 100) {  
          // 当扫码前有keypress事件时，防止首字母缺失
          code = e.key
          console.log('防止首字母缺失', code);
        } else if(lastCode && lastTime) {
          code += e.key
          console.log('扫码中', code);
        }
        lastCode = nextCode
        lastTime = nextTime
      }
    },
    parseQRCode(code) {
      if (code.length === 13 || code.length === 14 || code.length === 15 || code.length === 16 || code.length === 17) {
        console.log('barCode', code);
      } else if (code.length === 23 || code.length === 30) {
        console.log('B类条形码', code);
      } else if (code.length === 0) {
        console.log('请输入条码', code);
        this.$message({
          message: '请输入条码',
          type: 'error'
        })
        return
      } else {
        console.log('条码不合法', code);
        this.$message({
          message: '条码不合法',
          type: 'error'
        })
        return
      }
      this.register.expressCode = code
      this.registerFnc()
    }
  }
};
</script>
<style lang="scss" scoped>
.return-register {
  flex: 1;
  .register-container {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    .btn-blue,
    .btn-gray {
      margin-left: 16px;
    }
    .register-title {
      padding-left: 20px;
      height: 52px;
      line-height: 52px;
      background: #FFFFFF;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      border-bottom: 1px solid #F1F1F1;
    }
    .el-form {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 80px;
      .el-form-item {
        margin-bottom: 0px;
      }
    }
    .auto-submit {
      margin-left: 10px;
    }
  }
  .return-content {
    background: #fff;
    min-height: 500px;
    border-radius: 4px;
    .table {
      padding: 16px;
      .el-table {
        .price-container {
          display: flex;
          color: #666666;
        }
        .processed,
        .not-processed {
          width: 78px;
          height: 24px;
          line-height: 24px;
          border-radius: 4px;
          padding-left: 8px;
          i {
            font-size: 14px;
          }
        }
        .processed {
          background: #E4F5EF;
          color: #22A979;
        }
        .not-processed {
          background: #FFEDE7;
          color: #FF6A3A;
        }
      }
      .pagination {
        display: flex;
        justify-content: flex-end;
      }
    }
    .search-form {
      border-bottom: 1px solid #eee;
      margin-bottom: 4px;
      padding: 30px 16px 8px 16px;
      .search-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
}
</style>
<style lang="scss">
.return-register {
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    display: flex;
    align-items: center;
  }
}
</style>